import InfoIcon from "@mui/icons-material/Info";
import { Stack, Typography } from "@mui/material";

import { BG_ICON_COLOR } from "../../../../constants";

interface BookedPriceRevealUnavailableProps {
  message?: string;
}

export function BookedPriceRevealUnavailable(
  props: BookedPriceRevealUnavailableProps,
) {
  const { message } = props;

  return (
    <Stack
      direction="row"
      alignItems="flex-start"
      spacing={1.5}
      sx={{
        borderRadius: "6px",
        border: "1px solid",
        borderColor: "grey.300",
        bgcolor: "grey.50",
        px: 2,
        py: 2,
      }}
    >
      <InfoIcon sx={{ fontSize: 18, color: "grey.500", mt: 0.25 }} />
      <Stack>
        <Typography
          variant="body2"
          fontWeight={500}
          sx={{ color: BG_ICON_COLOR, mb: message != null ? 0.5 : 0 }}
        >
          The booked price comparison is not available for this shipment
        </Typography>
        {message != null && (
          <Typography variant="body2" sx={{ color: "text.secondary" }}>
            {message}
          </Typography>
        )}
      </Stack>
    </Stack>
  );
}
